import React from "react";
import EcomStore from "./ecom-store";
export default (props) => {
    return React.createElement(EcomStore, Object.assign({}, props));
};
